<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap">
      <section class="boss-contractperiod-container">
        <!-- ▼掲載期間見出し -->
        <scout-and-like-period-bar
          :first-date="contract.firstDate"
          :last-date="contract.lastDate"
          :scout-limit="contract.scoutLimit"
          :sent-scout-amount="contract.sentScoutAmount"
          :like-limit="contract.likeLimit"
          :sent-like-amount="contract.sentLikeAmount"
          :reserved-scout-first-send-amount="contract.reservedScoutFirstSendAmount"
        />
        <!-- ▲掲載期間見出し -->
        <div class="boss-contractperiod-wrap">
          <!-- ▼求人掲載中 container -->
          <div class="boss-posting-container">
            <div class="boss-posting-wrap boss-main-content-wrap">
              <scout-job-header
                :jobs="jobs"
                :is-selectable="isSelectable"
              />
              <scout-tab-menu
                :job-id="Number(jobId)"
                :contract-id="Number(contractId)"
              />
              <router-view />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ScoutAndLikePeriodBar from '@/components/molecules/ScoutandLikePeriodBar'
import ScoutTabMenu from '@/components/organisms/ScoutTabMenu'
import ScoutJobHeader from '@/components/molecules/ScoutJobHeader'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: { ScoutAndLikePeriodBar, ScoutTabMenu, ScoutJobHeader },
  data () {
    return {
      contractId: this.$route.params.contractId
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'contracts',
      'jobsBy'
    ]),
    jobId () {
      return this.$route.params.jobId
    },
    jobs () {
      return this.jobsBy(this.contractId).map(job => {
        return { id: job.id, name: job.managementName }
      })
    },
    contract () {
      return this.contracts(this.contractId)
    },
    isSelectable () {
      // 検索条件設定画面・スカウト作成画面では求人プルダウンを選択できない状態にしたいため、isSelectableをfalseで渡す。
      return this.$route.name !== 'scoutSearch' && this.$route.name !== 'scoutCreate'
    }
  },
  created () {
    this.fetchScoutAmount({ contractId: this.contractId })
    this.fetchLikeAmount({ contractId: this.contractId })
  },
  methods: {
    ...mapMutations('contracts', [
      'fetchScoutAmount',
      'fetchLikeAmount'
    ])
  }
}
</script>
